<autocomplete-component
	placeholder="Search performers..."
	prefixIcon="search"
	[resetOnCompletion]="true"
	[options]="options"
	[filter]="filter"
	(optionSelected)="selectPerformer($event)"
></autocomplete-component>
